import * as React from 'react';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { Picture } from '../Picture/Picture';
import { StyledLink } from '../../..';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';

const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  padding: ${rem(15)};
  text-decoration: none;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border: ${rem(1)} solid #cccccc;
  border-radius: ${rem(4)};
  color: black;
  height: 100%;
  position: relative;
`;

const RightSide = styled.div``;

const Name = styled.p`
  font-weight: 200;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  margin-top: 0px;
  margin-right: ${rem(15)};
`;

const Description = styled.div`
  font-size: 0.875rem;
  color: #aaaaaa;
  margin-bottom: 1rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  p {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
`;

const CloseIcon = styled.div`
  position: absolute;
  right: ${rem(10)};
  top: ${rem(10)};
`;

interface Props {
  productId: number;
  name: string;
  picture: string;
  description: string;
  onRemove: (productId: number) => void;
}

export function CompareProductSmall({
  productId,
  name,
  picture,
  description,
  onRemove,
}: Props) {
  return (
    <Wrapper className="CompareProductSmall">
      <Picture
        image={picture}
        width={80}
        height={80}
        alt={__('Obrázok vo fotogalerií')}
      />
      <RightSide>
        <Name> {name} </Name>
        <Description dangerouslySetInnerHTML={{ __html: description }} />
      </RightSide>

      <CloseIcon>
        <StyledLink
          onClick={() => {
            onRemove(productId);
          }}
        >
          <SvgIcon
            icon={IconType.close}
            cursor={'pointer'}
            fill={'#000000'}
            title={`${'Odstrániť z porovnania'}`}
          />
        </StyledLink>
      </CloseIcon>
    </Wrapper>
  );
}
